<template>
  <section class="full-width-bg">
    <div id="tour-step-4" class="container p-3">
      <h2 class="main-title">Conexão Cooperado</h2>

      <h3 class="section-title" v-if="connectionData.articles.length">Conhecimento da Nossa Comunidade</h3>
      <ArticleContentHome :articles="connectionData.articles" />

      <h3 class="section-title">Novidades do Conexão</h3>
      <NewsContentHome :news="connectionData.news" :loadingNewsIds="loadingNewsIds" />

      <div class="actions">
        <button type="button" class="btn-success" @click="browseContents">Explorar conteúdos</button>
      </div>
    </div>
  </section>
</template>

<script>
import ArticleContentHome from './ArticleContentHome.vue';
import NewsContentHome from './NewsContentHome.vue';
import RoutesPaths from '../../../router/router-structure/routes-paths.js';

export default {
  components: {
    ArticleContentHome,     
    NewsContentHome
  },
  props: {
    loadingNewsIds: {
      type: Array,
      default: () => []
    },
    connectionData: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {}
  },
  methods: {
    browseContents() {
      this.$router.push(RoutesPaths.connection.rootName());
    }
  },
}
</script>

<style scoped>
.full-width-bg {
  width: 100%;
  background-color: #fff;
  padding: 32px 0;
  display: flex;
  justify-content: center;
}

.container {
  width: 100%;
  max-width: 100rem;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  gap: 16px;
  font-family: "Trebuchet MS", sans-serif;
  padding: 0 1rem;
}

.main-title,
.section-title {
  color: #3D3F40;
  margin: 0;
}

.main-title {
  text-align: center;
  font-size: 28px;
  margin-bottom: 16px;
}

.section-title {
  font-size: 20px;
  font-weight: 700;
  padding-bottom: 10px;
}

.actions {
  text-align: center;
  margin-top: 24px;
}

.btn-success {
  background: #007A4A;
  color: #FFF;
  border: none;
  border-radius: 4px;
  padding: 8px 16px;
  font-size: 16px;
  cursor: pointer;
  transition: 0.2s;
}

.btn-success:hover {
  background-color: #005c38;
}
</style>